import Grid from '@mui/material/Grid';
import ScenariosProductSelectableDetailPanel from 'components/DetailPanels/ScenariosProductSelectableDetailPanel';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { setContextSearchProduct } from 'ducks/ui';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import docDefinition from 'reports/evaluation/evaluationProductScenarios';
import { getImmutableStoreData, groupBy } from 'selectors/generic';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/product/productSimple';
import noIcon from 'utils/tables/noIcon';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { currentUser } from 'selectors/currentUser';

pdfMake.addVirtualFileSystem(pdfFonts);

const Component = props => {
  const { compositionByProduct, contextSearch, lcsById, products, scenarios, user } = props;
  const { openDescriptors, openProductScenarios, setSearch } = props;

  const tableRef = useRef();

  const [filterCenario, setFilterCenarios] = useState(false);

  const onSelectingScenario = rowData => productScenario =>
    openDescriptors(rowData.id, productScenario.lcs_id);

  const exportPDF = () => {
    const filteredTableData = tableRef.current.state.data;
    pdfMake.createPdf(
      docDefinition(
        filteredTableData,
        lcsById,
        scenarios,
        'R - Listagem de Cenários Avaliação de Produto'
      ))
      .open();
  };

  const contributesToHazard = product =>
    (compositionByProduct[product.id] || []).some(mp => mp.contributes_to_hazard);

  let filteredProducts = products.filter(contributesToHazard);
  if (filterCenario) {
    filteredProducts = products
      .filter( product => scenarios.find(s => s.product_id && s.product_id == product.id))
      .filter(contributesToHazard);

  }

  return (
    <Grid size={12}>
      <BaseTable
        ref={tableRef}
        columns={columns(user)}
        data={filteredProducts}
        onRowClick={() => null}
        onRowDoubleClick={rowData => openProductScenarios(rowData.id)}
        onSearchChange={ text => setSearch(text)}
        options={{
          actionsCellStyle: {
            width: 150,
            paddingLeft: 20
          },
          searchText: contextSearch
        }}
        actions={[
          rowData => ({
            icon: scenarios.find(s => s.product_id && s.product_id == rowData.id) ?
              tableIcons.Scenarios() :
              tableIcons.ScenariosEmpty(),
            tooltip: 'Gerir cenários',
            onClick: (event, rowData) => openProductScenarios(rowData.id)
          }),
          // {
          //   icon: tableIcons.ContentCopy,
          //   tooltip: 'Copiar e criar cenário',
          //   onClick: (event, rowData) => {
          //     alert('Cópia de cenário ainda não implementada');
          //   }
          // }
          {
            isFreeAction: true,
            icon: tableIcons.Pdf,
            tooltip: 'Exportar PDF',
            onClick: exportPDF
          },
          {
            isFreeAction: true,
            icon: filterCenario ? tableIcons.FilterWrongStyled : tableIcons.FilterWrong,
            tooltip: 'Filtrar cenários',
            onClick: () => setFilterCenarios(!filterCenario)
          },

        ]}
        detailPanel={[
          rowData => {
            const productScenario = scenarios.find(s => s.product_id && s.product_id == rowData.id);
            if (productScenario) {
              return ScenariosProductSelectableDetailPanel(rowData, onSelectingScenario(rowData), scenarios, lcsById);
            } else {
              return noIcon;
            }
          }
        ]}
      />
    </Grid>
  );
};


const makeMapStateToProps = () => {
  const immutableProducts = getImmutableStoreData('products');
  // The composition rows indexed by product, rather than the copy nested in
  // each product.
  //
  // Built once, not on every call: createSelector keeps a single result, so a
  // selector created inside mapStateToProps has an empty cache every time and
  // reindexes the whole slice per render.
  //
  // The factory around it is this file matching the other fifty that use one,
  // and nothing more. It exists so each component instance can own its memo,
  // which matters for a selector that reads ownProps - two instances then hand
  // it different inputs and fight over the one cache slot. This one reads
  // state.productRawMaterials and nothing else, so every instance gives it the
  // same input and sharing would be fine, or slightly better.
  const compositionByProduct = groupBy('productRawMaterials', 'product_id');
  const mapStateToProps = (state, props) => ({
    contextSearch: state.ui.context.searchProduct,
    products: immutableProducts(state),
    compositionByProduct: compositionByProduct(state),
    scenarios: state.scenarios.data,
    lcsById: state.descriptors.models,
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  setSearch: search => dispatch(setContextSearchProduct(search))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
